export default __webpack_public_path__ + "static/media/edot_cloudxier4.f7489685.png";